import {
  formatDisplayDateTime,
  getFormatForDateFormat,
  getParsedNumber,
  roundNumber,
  serverImgFullPath,
} from "../utils/Common";
import { getFormatedFoodItems, getPhoneObj } from "./order-common-service";

export const getMediaLinks = (webAddress, socialLink) => {
  const web = webAddress || "";
  const social = socialLink || "";

  return {
    webAddress: web.replace(/^https?:\/\//, ""),
    socialLink: social.replace(/^https?:\/\//, ""),
  };
};

export const getFoodAddOnsTotalPrice = (addOns) => {
  const totalAddOnsPrice = addOns.reduce((total, item) => total + roundNumber(item.price * item.quantity), 0);
  return roundNumber(totalAddOnsPrice);
};


export const getCalculatedPaymentReceiveTypes = (orderRecord) => {
  if (orderRecord.paymentType && orderRecord.paymentType === "SSLC") {
    return [{ paymentReceiveType: "Online", amount: orderRecord.totalPrice }];
  }

  const paymentReceiveTypes = orderRecord?.paymentReceiveTypes || [];

  return paymentReceiveTypes.map((item) => {
    const amount = item.paymentReceiveType === "CASH" ? orderRecord.totalReturnAmount + item.amount : item.amount;
    item.amount = amount;
    item.paymentReceiveType = item.posBank || item.paymentReceiveType;
    return item;
  });
};

export function getFoodItemTotalPrice(food, selectedOption, selectedAddOns) {
  let total = 0;
  const options = food?.options || [];
  const currentSelectedOption = options.find((option) => option.optionId === selectedOption);

  if (!Boolean(currentSelectedOption)) return 0;

  total = total + currentSelectedOption.currentPrice;

  const addOns = selectedAddOns || [];
  const selectedAddOnsPrice = addOns.reduce((sum, sAddOn) => sum + sAddOn.price, 0);

  total += selectedAddOnsPrice;
  return total;
}

export const getCookingTimeFromExistingOrder = (startTime, endTime) => {
  if (!startTime || !endTime) return 0;

  const start = new Date(startTime);
  const end = new Date(endTime);
  const diffMs = end - start;
  const diffMins = diffMs / (1000 * 60);
  return diffMins;
};

export const formatOrderEditableRecord = (order, idWiseFoodsAdditionGroups = {}) => {
  const userPhoneObj = getPhoneObj(order.userPhone);

  return {
    orderId: order.id,
    orderType: order.orderType,
    orderNumber: order.orderNumber,
    countryCode: userPhoneObj.countryCode,
    phone: userPhoneObj.phone,
    tableNumber: order.tableNumber,
    guests: order.guests,
    foods: getFormatedFoodItems(order.foods, idWiseFoodsAdditionGroups),
    payAfterEat: order.payAfterEat,
    totalPrice: order.totalPrice,
    totalPriceBeforeDiscount: order.totalPriceBeforeDiscount,
    vat: order.vat,
    serviceCharge: order.serviceCharge,
    restaurantId: order.restaurantId,
    comment: order.comment,
    cookingTime: getCookingTimeFromExistingOrder(order.acceptedAt, order.deliveryTime),
    paymentStatus: order.paymentStatus,
  };
};

export const getDefaultValueForPayLater = (orderRecord) => {
  let payLater = true;

  if (!orderRecord) {
    return payLater;
  }

  if (orderRecord.status !== "pending" && orderRecord.paid === 0 && orderRecord.payAfterEat) {
    payLater = false;
  }

  return payLater;
};

export const getPaymentStatusForOrderList = (record) => {
  let status = record.paymentStatus === 1 ? "Paid" : "Unpaid";

  if (record.paymentStatus !== 1 && record.payAfterEat) {
    status = "Pay after eat";
  }

  return status;
};

export const getItemTotalPrice = (foodItem) => {
  const itemTotalPrice = roundNumber(foodItem.option.price * foodItem.quantity);
  let totalAddOnsPrice = foodItem.addOns.reduce((total, item) => total + roundNumber(item.price * item.quantity), 0);
  totalAddOnsPrice = roundNumber(totalAddOnsPrice);

  let totalAdditionsPrice = foodItem.additionGroups.reduce(
    (total, item) => total + getParsedNumber(item.totalPriceOfSelectedItems),
    0
  );
  totalAdditionsPrice = roundNumber(totalAdditionsPrice);
  return roundNumber(itemTotalPrice + totalAddOnsPrice + totalAdditionsPrice);
};

export const getFormatedOrderDataForList = (record, page = 1) => {
  try {
    if (!record) {
      return null;
    }
    const foods = record.foods
      .filter((item) => item.foodType === "SINGLE_FOOD")
      .map((item) => ({
        food_image: serverImgFullPath(item.image, "/images/tabletap.svg"),
        name: item.name,
        category: "Pizza",
        variant: item.option.name,
        unitPrice: item.option.price,
        addOns: item.addOns,
        qty: item.quantity,
        price: getItemTotalPrice(item),
      }));

    const setMenus = record.foods.filter((item) => item.foodType !== "SINGLE_FOOD");

    const userPhoneObj = getPhoneObj(record.userPhone);

    let discountApplicablePrice = 0;

    if (record.subtotalObj) {
      discountApplicablePrice = roundNumber(
        record.subtotalObj.vatApplicableDiscountApplicableSubtotal +
          record.subtotalObj.vatNotApplicableDiscountApplicableSubtotal
      );
    }

    return {
      _id: record.id,
      orderId: record.id,
      order_id: record.orderNumber,
      orderNumber: record.orderNumber,
      date: getFormatForDateFormat(record.createdAt),
      name: userPhoneObj.phone,
      countryCode: userPhoneObj.countryCode,
      number: record.userPhone,
      userId: record.userId,
      customerName: record.userName || "",
      amount: record.foodPrice,
      paymentType: record.paymentType,
      delivery_time: getFormatForDateFormat(record.deliveryTime),
      status: record.orderStatus.toLowerCase(),
      paid: record.paymentStatus,
      item_total: record.foodPrice,
      discount: record.staffDiscount ?? null,
      staffDiscount: record.staffDiscount,
      loyaltyDiscount: record.loyaltyDiscount,
      couponDiscount: record.couponDiscount,
      total: record.totalPrice,
      totalPriceBeforeDiscount: record.totalPriceBeforeDiscount,
      discountApplicablePrice: discountApplicablePrice,
      service_charge: record.serviceCharge,

      foodPrice: record.foodPrice, // new
      foodPriceBeforeDiscount: record.foodPriceBeforeDiscount, // new
      sd: record.sd,
      serviceCharge: record.serviceCharge,
      serviceChargePercent: record.serviceChargePercent,
      vat: record.vat,
      vatPercent: record.vatPercent,
      isVatIncluded: record.isVatIncluded,
      isServiceChargeIncluded: record.isServiceChargeIncluded,
      isSupplementaryDutyIncluded: record.isSupplementaryDutyIncluded,
      subtotalObj: record.subtotalObj,
      sdObj: record.sdObj,

      items: foods,
      payAfterEat: record.payAfterEat,

      refundAmount: record?.refundInfo?.totalRefundAmount || "",
      refundInfo: record?.refundInfo ?? null,
      discountAmount: record?.staffDiscount?.discountAmount || "",
      editLogs: record?.staffOrderEditLogs || [],
      changeLogs: record?.statusChangeLogs || [],
      totalFoodItems: foods.length + setMenus.length,
      paymentStatusText: getPaymentStatusForOrderList(record),
      tableNumber: record?.tableNumber || null,
      orderType: record.orderType,
      comment: record.comment || "",
      paginationPageNo: page,
      restaurantInfo: record?.restaurantInfo || {},
      base64DataPrint: record.base64DataPrint,
    };
  } catch (error) {
    console.error("An error occurred while retrieving token. ", error);
    return null;
  }
};

export const getFormatedOrderList = (record, page = 1) => {
  try {
    if (!record) {
      return null;
    }

    const userPhoneObj = getPhoneObj(record.userPhone);
    let discountApplicablePrice = 0;

    if (record.subtotalObj) {
      discountApplicablePrice = roundNumber(
        record.subtotalObj.vatApplicableDiscountApplicableSubtotal +
          record.subtotalObj.vatNotApplicableDiscountApplicableSubtotal
      );
    }

    return {
      _id: record.id,
      orderId: record.id,
      order_id: record.orderNumber,
      orderNumber: record.orderNumber,
      tableNumber: record?.tableNumber || null,
      date: getFormatForDateFormat(record.createdAt),
      name: userPhoneObj.phone,
      countryCode: userPhoneObj.countryCode,
      number: record.userPhone,
      userId: record.userId,
      customerName: record.userName || "",
      isVatIncluded: record.isVatIncluded,
      isServiceChargeIncluded: record.isServiceChargeIncluded,
      isSupplementaryDutyIncluded: record.isSupplementaryDutyIncluded,
      vatPercent: record.vatPercent,
      serviceChargePercent: record.serviceChargePercent,
      sd: record.sd,
      serviceCharge: record.serviceCharge,
      vat: record.vat,
      subtotalObj: record.subtotalObj,
      sdObj: record.sdObj,
      total: record.totalPrice,
      totalPriceBeforeDiscount: record.totalPriceBeforeDiscount,
      foodPrice: record.foodPrice, // new
      foodPriceBeforeDiscount: record.foodPriceBeforeDiscount, // new
      discountApplicablePrice: discountApplicablePrice,
      paymentStatusText: getPaymentStatusForOrderList(record),
      payAfterEat: record.payAfterEat,
      staffDiscount: record.staffDiscount,
      loyaltyDiscount: record.loyaltyDiscount,
      couponDiscount: record.couponDiscount,
      refundAmount: record?.refundInfo?.totalRefundAmount || "",
      refundInfo: record?.refundInfo ?? null,
      totalFoodItems: record.totalFoodItems,
      delivery_time: getFormatForDateFormat(record.deliveryTime),
      comment: record.comment || "",
      orderType: record.orderType,
      status: record.orderStatus.toLowerCase() || "",
      paid: record.paymentStatus,
      paginationPageNo: page,
    };
  } catch (error) {
    console.error("An error occurred while retrieving token. ", error);
    return null;
  }
};

export const getSubtotalPriceToDisplay = (order) => {
  if (!order || !order.hasOwnProperty("isVatIncluded")) {
    return 0;
  }

  if (order.isVatIncluded) {
    return order?.totalPriceBeforeDiscount || 0;
  }

  return order.foodPriceBeforeDiscount || order.foodPrice;
};

export const getFormatedOrderDetailsData = (data) => {
  let authStorage = localStorage.getItem("auth-storage");
  authStorage = JSON.parse(authStorage);
  const { state } = authStorage;
  const branch = state.branches.find((item) => item.restaurantId === data.restaurantId);
  const totalPaidAmount = data.paymentReceiveTypes.reduce((total, item) => total + item.amount, 0);
  const customerInfo = {
    id: data.userId,
    name: data.userName,
    phoneNumber: data.userPhone,
  };
  const mediaLinks = getMediaLinks(state.webAddress, state.socialLink);

  const discountApplicablePrice = roundNumber(
    data.subtotalObj.vatApplicableDiscountApplicableSubtotal +
      data.subtotalObj.vatNotApplicableDiscountApplicableSubtotal
  );

  return {
    orderId: data.id,
    tableNumber: data.tableNumber,
    orderType: data.orderType,
    restaurantId: data.restaurantId,
    restaurantAddress: state.restaurantAddress,
    orderNumber: data.orderNumber,
    orderDate: formatDisplayDateTime(data?.createdAt),
    restaurantName: branch.name,
    branchName: branch.branch,
    logo: state.restaurantLogo,
    bin: state.restaurantBin,
    mushak: state.restaurantMushak,
    socialLink: mediaLinks.socialLink,
    webAddress: mediaLinks.webAddress,
    discount: data?.staffDiscount?.discountAmount ?? 0,
    staffDiscount: data?.staffDiscount,
    loyaltyDiscount: data.loyaltyDiscount,
    couponDiscount: data.couponDiscount,
    totalPaidAmount,
    loyaltyPointsBalance: data.loyaltyPointsBalance || 0,
    isLoyaltyApplicable: data.isLoyaltyApplicable,
    totalReturnAmount: data?.totalReturnAmount || 0,
    isVatIncluded: data.isVatIncluded,
    isServiceChargeIncluded: data.isServiceChargeIncluded,
    isSupplementaryDutyIncluded: data.isSupplementaryDutyIncluded,
    serviceChargePercent: data?.serviceChargePercent || 0,
    vatPercent: data?.vatPercent || 0,
    sd: data.sd,
    serviceCharge: data.serviceCharge,
    vat: data.vat,
    subtotalObj: data.subtotalObj,
    sdObj: data.sdObj,
    paymentStatus: data.paymentStatus,
    paymentReceiveTypes: getCalculatedPaymentReceiveTypes(data),
    rounded: getParsedNumber(data.rounded),
    totalPriceBeforeRounding: data.totalPriceBeforeRounding,
    subTotal: getSubtotalPriceToDisplay(data),
    totalPriceBeforeDiscount: data.totalPriceBeforeDiscount,
    totalPrice: data.totalPrice,
    discountApplicablePrice: discountApplicablePrice,
    phoneNumber: `+${state.restaurantCountryCode}${state.restaurantPhone}`,
    staffName: data?.paymentReceivedBy?.name ?? "",
    customerInfo,
    foods: data.foods,
    comment: data.comment,
  };
};

export const getNetTotalOrderDetails = (order) => {
  const subtotal = getSubtotalPriceToDisplay(order);

  if (order?.staffDiscount) {
    return roundNumber(subtotal - order.staffDiscount.discountAmount);
  }

  if (order?.loyaltyDiscount) {
    return roundNumber(subtotal - order.loyaltyDiscount.discountAmount);
  }

  if (order?.couponDiscount) {
    return roundNumber(subtotal - order.couponDiscount.discountAmount);
  }

  return subtotal;
};
